/* jshint browserify: true */
'use strict';

var $ = require('jquery');
var $currentFocusTrappedElement = null;

function onFocus(event) {
    if (!$.contains($currentFocusTrappedElement[0], event.target) && ($currentFocusTrappedElement[0] !== event.target)) {
        event.stopPropagation();
        $currentFocusTrappedElement.focus();
    }
}

function trap(element, opt) {
    var $element = $(element),
        options = opt || {},
        $elementToFocus = options.elementToFocus ? $(options.elementToFocus) : $element;

    untrap();

    $element
        .attr('tabindex', '-1');

    $elementToFocus.focus();
    $currentFocusTrappedElement = $element;

    document.addEventListener('focus', onFocus, true);
}

function untrap() {
    document.removeEventListener('focus', onFocus, true);
}

module.exports = {
    trap: trap,
    untrap: untrap,
};
